export default __webpack_public_path__ + "static/media/banner@3x.cf154eef.webp";